import { useQuery } from '@tanstack/react-query'
import React from 'react'
import { Link } from 'react-router-dom'
import { apiClient } from '../../../api/client'
import { myRewards } from '../../../dummy/my-rewards'
import { ICommonResponse } from '../../../core/api/http-methods/common-response.type'

type EntitySummary = {
  entity_id: string;
  entity_name: string | null;
  entity_logo_image: string | null;
};

type GetRewardBrandsResponse = ICommonResponse<EntitySummary[]>;


const RewardsSection: React.FC = () => {
  const joinedRewards = myRewards.joinedRewards;

  const { data } = useQuery<GetRewardBrandsResponse>({
    queryKey: ["getRewardBrands"],
    queryFn: async () => {
      const resp = await apiClient.get('/users/reward-brands');
      return resp.data;
    },
  });

  let entities;
  if (data?.success) {
    entities = data?.data || [];
  }

  return (
    <section className="mx-auto mt-8 max-w-full px-4 pb-6 sm:px-6 lg:px-8 flex w-full flex-col gap-y-4">

      <div className='p-1'>
        <h2 className='text-lg flex-1 flex flex-nowrap items-center font-semibold text-gray-900'>
          My Rewards Hub
        </h2>
      </div>
      <div className="grid grid-cols-5 gap-y-4 md:grid-cols-5 md:gap-x-4">
        {entities?.slice(0, 9).map(entity => (
          <Link
            to={`/my-rewards-hub/${entity.entity_id}`}
            className="flex flex-col md:flex-row md:justify-start justify-center items-center gap-y-2 md:gap-x-4"
          >
            <div className='size-14 md:size-20 shadow-lg rounded-2xl bg-white p-2'>
              <img
                src={entity?.entity_logo_image || ''}
                alt={entity?.entity_name || ''}
                className='size-full object-contain'
              />
            </div>
            <p className='text-xs md:text-base font-normal line-clamp-1 md:line-clamp-none md:w-[calc(100%-6rem)]'>
              {entity.entity_name}
            </p>
          </Link>
        ))}

        {/* {joinedRewards.slice(0, 8).map((brand, index) => (
          <Link
            to={`/my-rewards-hub/${brand.id}`}
            className="flex flex-col md:flex-row md:justify-start justify-center items-center gap-y-2 md:gap-x-4"
          >
            <div className='size-14 md:size-20 shadow-lg rounded-2xl bg-white p-2'>
              <img
                src={brand.logo}
                alt={brand.brand}
                className='size-full object-contain'
              />
            </div>
            <p className='text-xs md:text-base font-normal line-clamp-1 md:line-clamp-none md:w-[calc(100%-6rem)]'>
              {brand.brand}
            </p>
          </Link>
        ))} */}

          <Link
            to={`/my-rewards-hub`}
            className="flex flex-col md:flex-row md:justify-start justify-center items-center gap-y-2 md:gap-x-4"
          >
            <div className='size-14 md:size-20 shadow-lg rounded-2xl bg-white p-2'>
              <img
                src={'/assets/images/see-more.svg'}
                alt={'See More'}
                className='size-full object-contain'
              />
            </div>
            <p className='text-xs md:text-base font-normal line-clamp-1 md:line-clamp-none'>
              See More
            </p>
          </Link>
      </div>
    </section>
  )
}

export default RewardsSection